// extracted by mini-css-extract-plugin
export default {"mailingListsBox":"mailingLists_mailingListsBox__yyvBL","contentBox":"mailingLists_contentBox__XEC6-","modalFormBox":"mailingLists_modalFormBox__2MmuC"};